import React, {useRef} from 'react'
import {useOnScreen} from './useOnScreen'

export const PrizeIntro = ({prize, imageRight, show2021=false, className=null}) => {
    const imgRef = useRef(null)
    const fadeAlready = useOnScreen(imgRef, 'fade-already')

    return (
        <div className={`prize-intro ${className}`}>
            <div className={`prize-img-section ${imageRight && 'img-right'}`}>
                <div className={`fade-bar`}  ref={imgRef}/>
                <img src={prize.img} className={`prize-img ${fadeAlready}`}/>
            </div>
            <div className={`prize-info ${imageRight && 'img-right'}`}>
                <div className='border-bottom prize-logo'>
                    <img src={prize.logo} />
                </div>
                <p className='prize-title border-bottom'>{prize.title}</p>
                <p className='prize-price'>{prize.price}</p>
            </div>
        </div>
    )
}